import { useEffect, useId, useRef, useState } from "react";
import { useDispatch, useSelector, useStore } from "react-redux";
import { useNavigate } from "react-router-dom";
import { applyCartDiscountCode, removeCartDiscount, reconcileCart } from "../../api/shop";
import { updateCart, updateCartDiscounts, setCartDiscountBusy } from "../../reducers/userConfigSlice";
import { cartIntent, serverCart } from "../../hooks/cartPersistence";
import { logoutRevision } from "../../hooks/shopSession";
import "./style.css";

export const CartCoupon = () => {
 const id = useId(), dispatch = useDispatch(), navigate = useNavigate(), store = useStore();
 const user = useSelector(state => state.aplicationConfig.userConfig);
 const [code, setCode] = useState(""), [message, setMessage] = useState(null);
 const alive = useRef(true);
 useEffect(() => { alive.current = true; return () => { alive.current = false; }; }, []);
 const mutate = async discountId => {
  const start = store.getState().aplicationConfig.userConfig;
  if (start.cartDiscountBusy || !start.logged || (!discountId && !code.trim())) return;
  const revision = logoutRevision(), intent = JSON.stringify(cartIntent(start.cart, true));
  const valid = () => revision === logoutRevision();
  dispatch(setCartDiscountBusy(true)); setMessage(null);
  try {
   const synced = await reconcileCart(cartIntent(start.cart, true));
   if (!valid()) return;
   if (synced?.error || !synced?.data?.shoppingCartId) throw new Error("No se pudo guardar el carrito. Reinténtalo.");
   if (JSON.stringify(cartIntent(store.getState().aplicationConfig.userConfig.cart, true)) !== intent) throw new Error("El carrito ha cambiado. Revisa los productos y vuelve a intentarlo.");
   const cart = serverCart(synced.data);
   dispatch(updateCart(cart));
   const result = discountId ? await removeCartDiscount(cart.shoppingCartId, discountId) : await applyCartDiscountCode(cart.shoppingCartId, code.trim());
   if (!valid()) return;
   if (result?.error || !Array.isArray(result?.data?.discounts)) throw new Error(result?.message || "No se pudo confirmar el cambio. Revisa el carrito e inténtalo de nuevo.");
   dispatch(updateCartDiscounts({shoppingCartId:cart.shoppingCartId, discounts:result.data.discounts}));
   if (alive.current) { if (!discountId) setCode(""); setMessage({error:false,text:discountId ? "Código eliminado." : "Código aplicado. El total se recalcula con sus condiciones."}); }
  } catch (error) {
   if (valid() && alive.current) setMessage({error:true,text:error.message || "No se pudo aplicar el código. Inténtalo de nuevo."});
  } finally { if (valid()) dispatch(setCartDiscountBusy(false)); }
 };
 if (!(user.cart?.ShoppingCartProducts || []).length) return null;
 return <section className="shop-cart-coupon" aria-label="Código de descuento">
  {user.logged ? <>
   <form onSubmit={event => {event.preventDefault();mutate();}} aria-busy={Boolean(user.cartDiscountBusy)}>
    <label htmlFor={id}>Código de descuento</label>
    <div className="shop-coupon-entry"><input id={id} name="discountCode" autoComplete="off" maxLength={255} value={code} onChange={event=>setCode(event.target.value)} disabled={user.cartDiscountBusy} /><button type="submit" disabled={user.cartDiscountBusy || !code.trim()}>{user.cartDiscountBusy ? "Actualizando…" : "Aplicar"}</button></div>
   </form>
   {(user.cart.Discounts || []).map(discount=><div className="shop-coupon-applied" key={discount.discountId}><span>{discount.discountCode || discount.name}</span><button type="button" disabled={user.cartDiscountBusy} aria-label={`Quitar código ${discount.discountCode || discount.name}`} onClick={()=>mutate(discount.discountId)}>Quitar</button></div>)}
   {message && <p role={message.error ? "alert" : "status"}>{message.text}</p>}
  </> : <button type="button" onClick={()=>navigate("/login?returnTo=%2Fcarrito")}>Inicia sesión para aplicar un código de descuento</button>}
 </section>;
};
